<template>
  <div class="home">
    <Carousel />
    <div class="pre-order">
      <!-- <p class="arrow left">&#10095; &#10095;</p> -->
      <!-- <localized-link to="commande">
        <span class="button__car-icon"><img src="@/assets/img/icons/car.svg" alt="car"></span>
      </localized-link> -->
      <localized-link to="commande">
        <span class="button button--primary">
        <span class="button__text"><inline-svg :src="require('@/assets/img/icons/car.svg')" ></inline-svg> {{$t('cta.order')}}</span>
      </span>
      </localized-link>
      <!-- <p class="arrow right">&#10094; &#10094;</p> -->
    </div>
    <Avantages />
    <Guarantees />
    <Faq />
    <!-- <Map /> -->
    <Blog />
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    Carousel  : () => import('@/components/Home/Carousel.vue'),
    Avantages : () => import('@/components/Avantages.vue'),
    Guarantees: () => import('@/components/Home/Guarantees.vue'),
    Faq       : () => import('@/components/Faq.vue'),
    Map       : () => import('@/components/Home/Map.vue'),
    Blog       : () => import('@/components/Home/Blog.vue'),
  }
}
</script>

<style scoped lang="scss">
.pre-order {
  text-align: center;
  margin: rem(40) 0 rem(80);
  // animation: bounce 3s;
  // animation-direction: alternate;
  // animation-iteration-count: infinite;
  .button {
    max-width: initial;
    height: rem(60);
    padding: rem(16) rem(30);
    &__text {
      @include font-size(22);
      svg {
        vertical-align: middle;
        max-width: rem(40);
        margin-right: rem(8);
        fill: $white;
        transition: fill 0.6s ease-in-out;
      }
    }
    &:hover {
      svg {
        fill: $black;
      }
    }
  }
  .arrow {
    display: inline-block;
    @include font-size(56);
    vertical-align: middle;
    &.left {
      margin-right: rem(20);
    }
    &.right {
      margin-left: rem(20);
    }
  }
  @include breakpoint('charmander') {
    margin: rem(40) 0 0;
    // animation: bounce2 3s;
    // animation-direction: alternate;
    // animation-iteration-count: infinite;
    padding: 0 rem(20);
    .arrow {
      display: none;
    }
    .button {
      display: block;
      max-width: 100%;
      height: rem(46);
      padding: rem(5) rem(12);
      svg {
        max-width: rem(32);
      }
      &__text {
        @include font-size(16);
      }
    }
  }
}
.button__car-icon {
  background-color: $dark;
  display: inline-block;
  height: rem(60);
  padding: rem(16) rem(10);
  vertical-align: middle;
  svg {
    width: 100%;
    max-width: rem(50);
  }
  @include breakpoint('charmander') {
    position: absolute;
    top: 0;
    left: rem(10);
    height: rem(46);
    padding: rem(12) rem(10);
    z-index: 3;
    svg {
      max-width: rem(40);
    }
  }
}
@keyframes bounce { 
  0% { transform: translate3d(0, 0, 0); }
  60% { transform: translate3d(0, 0, 0); }
  80% { transform: translate3d(0, -50px, 0); }
  100% { transform: translate3d(0, 0, 0); }
}
@keyframes bounce2 { 
  0% { transform: translate3d(0, 0, 0); }
  60% { transform: translate3d(0, 0, 0); }
  80% { transform: translate3d(0, 20px, 0); }
  100% { transform: translate3d(0, 0, 0); }
}
</style>
